export default __webpack_public_path__ + "static/media/our-service-industrial-content.a4d35178.jpg";